import { id } from './assigned';

export const assigned = {
  ...id,
};
